import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import styles from '../styles'
import { messages } from './messages'

export function GiftReview() {
  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.gift}
        values={{ tag: (content) => <Tag>{content}</Tag> }}
      />
    </SummaryRow.Value>
  )
}
